export const vars: any = {
  primaryFont: "'DM Sans', sans-serif",
  secondaryFont: "'Epilogue', sans- serif",
  primaryColor: '#00C385',
  stepperBg: '#E5EBFF',
  primaryHoverColor: '#019F6C',
  secondaryColor: '#161458',
  secondaryHoverColor: '#B1B3EA',
  blackColor: '#000000',
  lightYellow: '#F6F3ED',
  errorColor: '#ff0000',
  greyLight: '#6E6F70',
  grey: '#bababa',
  greyDark: '#9E9E9E',
  textColor: '#292929',
  secondaryTextColor: '#A5AAB7',
  whiteColor: '#ffffff',
  leftPanelBg: '#ECF0FC',
  secondaryButtonColor: '#2378DB',
  secondaryButtonHoverColor: '#E8F2FF'
}